'use client';

import { Button } from '@/components/ui/button';

/**
 * Reply chips.
 *
 * Bounded server-side to 1–4 options of at most 80 characters, so they are
 * safe to lay out inline. Clicking one sends it as if the user had typed it.
 */
export function SuggestionChips({
  options,
  onPick,
  disabled = false,
}: {
  options: string[];
  onPick: (option: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((option) => (
        <Button
          key={option}
          type="button"
          variant="outline"
          size="sm"
          disabled={disabled}
          className="h-auto whitespace-normal py-1 text-left text-xs"
          onClick={() => onPick(option)}
        >
          {option}
        </Button>
      ))}
    </div>
  );
}
